import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const RegisterSupplierSlice = createSlice({
    name: "registerSupplier",
    initialState,
    reducers: {
        registerSupplierRequest(state) {
            state.loading = true;
        },
        registerSupplierRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        registerSupplierRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        registerSupplierStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    registerSupplierRequest,
    registerSupplierRequestSuccess,
    registerSupplierRequestError,
    registerSupplierStateReset
} = RegisterSupplierSlice.actions;

export default RegisterSupplierSlice.reducer;
